var cov_1nywdp1kkt = function () {
  var path = "/Users/spana/SHEIN/shineout/src/utils/shallowEqual.ts",
      hash = "790e6731d090d4a027ecc51d3c50ffe6e87e064e",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/utils/shallowEqual.ts",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 27
        },
        end: {
          line: 7,
          column: 43
        }
      },
      "1": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 12,
          column: 3
        }
      },
      "2": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 48
        }
      },
      "3": {
        start: {
          line: 14,
          column: 2
        },
        end: {
          line: 14,
          column: 27
        }
      },
      "4": {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 18,
          column: 30
        }
      },
      "5": {
        start: {
          line: 18,
          column: 21
        },
        end: {
          line: 18,
          column: 30
        }
      },
      "6": {
        start: {
          line: 19,
          column: 14
        },
        end: {
          line: 19,
          column: 26
        }
      },
      "7": {
        start: {
          line: 20,
          column: 2
        },
        end: {
          line: 20,
          column: 41
        }
      },
      "8": {
        start: {
          line: 27,
          column: 2
        },
        end: {
          line: 27,
          column: 41
        }
      },
      "9": {
        start: {
          line: 27,
          column: 30
        },
        end: {
          line: 27,
          column: 41
        }
      },
      "10": {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 28,
          column: 55
        }
      },
      "11": {
        start: {
          line: 28,
          column: 43
        },
        end: {
          line: 28,
          column: 55
        }
      },
      "12": {
        start: {
          line: 29,
          column: 24
        },
        end: {
          line: 31,
          column: 3
        }
      },
      "13": {
        start: {
          line: 30,
          column: 14
        },
        end: {
          line: 30,
          column: 105
        }
      },
      "14": {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 32,
          column: 34
        }
      },
      "15": {
        start: {
          line: 32,
          column: 22
        },
        end: {
          line: 32,
          column: 34
        }
      },
      "16": {
        start: {
          line: 33,
          column: 25
        },
        end: {
          line: 37,
          column: 4
        }
      },
      "17": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 35,
          column: 72
        }
      },
      "18": {
        start: {
          line: 35,
          column: 6
        },
        end: {
          line: 35,
          column: 72
        }
      },
      "19": {
        start: {
          line: 35,
          column: 41
        },
        end: {
          line: 35,
          column: 71
        }
      },
      "20": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 40
        }
      },
      "21": {
        start: {
          line: 38,
          column: 2
        },
        end: {
          line: 38,
          column: 23
        }
      },
      "22": {
        start: {
          line: 42,
          column: 2
        },
        end: {
          line: 44,
          column: 3
        }
      },
      "23": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 15
        }
      },
      "24": {
        start: {
          line: 46,
          column: 2
        },
        end: {
          line: 48,
          column: 3
        }
      },
      "25": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 16
        }
      },
      "26": {
        start: {
          line: 50,
          column: 16
        },
        end: {
          line: 50,
          column: 33
        }
      },
      "27": {
        start: {
          line: 51,
          column: 16
        },
        end: {
          line: 51,
          column: 33
        }
      },
      "28": {
        start: {
          line: 53,
          column: 15
        },
        end: {
          line: 53,
          column: 41
        }
      },
      "29": {
        start: {
          line: 54,
          column: 15
        },
        end: {
          line: 54,
          column: 41
        }
      },
      "30": {
        start: {
          line: 56,
          column: 2
        },
        end: {
          line: 58,
          column: 3
        }
      },
      "31": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 16
        }
      },
      "32": {
        start: {
          line: 60,
          column: 2
        },
        end: {
          line: 60,
          column: 57
        }
      },
      "33": {
        start: {
          line: 60,
          column: 23
        },
        end: {
          line: 60,
          column: 56
        }
      },
      "34": {
        start: {
          line: 63,
          column: 2
        },
        end: {
          line: 79,
          column: 3
        }
      },
      "35": {
        start: {
          line: 64,
          column: 14
        },
        end: {
          line: 64,
          column: 22
        }
      },
      "36": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 34
        }
      },
      "37": {
        start: {
          line: 65,
          column: 26
        },
        end: {
          line: 65,
          column: 34
        }
      },
      "38": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 78,
          column: 5
        }
      },
      "39": {
        start: {
          line: 68,
          column: 6
        },
        end: {
          line: 71,
          column: 7
        }
      },
      "40": {
        start: {
          line: 69,
          column: 8
        },
        end: {
          line: 69,
          column: 61
        }
      },
      "41": {
        start: {
          line: 69,
          column: 49
        },
        end: {
          line: 69,
          column: 61
        }
      },
      "42": {
        start: {
          line: 70,
          column: 8
        },
        end: {
          line: 70,
          column: 16
        }
      },
      "43": {
        start: {
          line: 73,
          column: 6
        },
        end: {
          line: 77,
          column: 7
        }
      },
      "44": {
        start: {
          line: 74,
          column: 8
        },
        end: {
          line: 74,
          column: 54
        }
      },
      "45": {
        start: {
          line: 74,
          column: 42
        },
        end: {
          line: 74,
          column: 54
        }
      },
      "46": {
        start: {
          line: 76,
          column: 8
        },
        end: {
          line: 76,
          column: 20
        }
      },
      "47": {
        start: {
          line: 81,
          column: 2
        },
        end: {
          line: 81,
          column: 13
        }
      }
    },
    fnMap: {
      "0": {
        name: "is",
        decl: {
          start: {
            line: 9,
            column: 9
          },
          end: {
            line: 9,
            column: 11
          }
        },
        loc: {
          start: {
            line: 9,
            column: 36
          },
          end: {
            line: 15,
            column: 1
          }
        },
        line: 9
      },
      "1": {
        name: "getOption",
        decl: {
          start: {
            line: 17,
            column: 9
          },
          end: {
            line: 17,
            column: 18
          }
        },
        loc: {
          start: {
            line: 17,
            column: 57
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 17
      },
      "2": {
        name: "compareColumns",
        decl: {
          start: {
            line: 26,
            column: 16
          },
          end: {
            line: 26,
            column: 30
          }
        },
        loc: {
          start: {
            line: 26,
            column: 73
          },
          end: {
            line: 39,
            column: 1
          }
        },
        line: 26
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 5
          }
        },
        loc: {
          start: {
            line: 30,
            column: 14
          },
          end: {
            line: 30,
            column: 105
          }
        },
        line: 30
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 33,
            column: 40
          },
          end: {
            line: 33,
            column: 41
          }
        },
        loc: {
          start: {
            line: 33,
            column: 50
          },
          end: {
            line: 37,
            column: 3
          }
        },
        line: 33
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 35,
            column: 27
          },
          end: {
            line: 35,
            column: 28
          }
        },
        loc: {
          start: {
            line: 35,
            column: 41
          },
          end: {
            line: 35,
            column: 71
          }
        },
        line: 35
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 41,
            column: 15
          },
          end: {
            line: 41,
            column: 16
          }
        },
        loc: {
          start: {
            line: 41,
            column: 61
          },
          end: {
            line: 82,
            column: 1
          }
        },
        line: 41
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 60,
            column: 13
          },
          end: {
            line: 60,
            column: 14
          }
        },
        loc: {
          start: {
            line: 60,
            column: 23
          },
          end: {
            line: 60,
            column: 56
          }
        },
        line: 60
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        }, {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        }],
        line: 10
      },
      "1": {
        loc: {
          start: {
            line: 11,
            column: 11
          },
          end: {
            line: 11,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 11,
            column: 11
          },
          end: {
            line: 11,
            column: 18
          }
        }, {
          start: {
            line: 11,
            column: 22
          },
          end: {
            line: 11,
            column: 29
          }
        }, {
          start: {
            line: 11,
            column: 33
          },
          end: {
            line: 11,
            column: 48
          }
        }],
        line: 11
      },
      "2": {
        loc: {
          start: {
            line: 14,
            column: 9
          },
          end: {
            line: 14,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 14,
            column: 9
          },
          end: {
            line: 14,
            column: 16
          }
        }, {
          start: {
            line: 14,
            column: 20
          },
          end: {
            line: 14,
            column: 27
          }
        }],
        line: 14
      },
      "3": {
        loc: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 30
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 30
          }
        }, {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 30
          }
        }],
        line: 18
      },
      "4": {
        loc: {
          start: {
            line: 20,
            column: 9
          },
          end: {
            line: 20,
            column: 41
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 30
          },
          end: {
            line: 20,
            column: 33
          }
        }, {
          start: {
            line: 20,
            column: 36
          },
          end: {
            line: 20,
            column: 41
          }
        }],
        line: 20
      },
      "5": {
        loc: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 41
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 41
          }
        }, {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 41
          }
        }],
        line: 27
      },
      "6": {
        loc: {
          start: {
            line: 27,
            column: 6
          },
          end: {
            line: 27,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 27,
            column: 6
          },
          end: {
            line: 27,
            column: 15
          }
        }, {
          start: {
            line: 27,
            column: 19
          },
          end: {
            line: 27,
            column: 28
          }
        }],
        line: 27
      },
      "7": {
        loc: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 55
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 55
          }
        }, {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 55
          }
        }],
        line: 28
      },
      "8": {
        loc: {
          start: {
            line: 30,
            column: 14
          },
          end: {
            line: 30,
            column: 105
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 14
          },
          end: {
            line: 30,
            column: 43
          }
        }, {
          start: {
            line: 30,
            column: 48
          },
          end: {
            line: 30,
            column: 69
          }
        }, {
          start: {
            line: 30,
            column: 73
          },
          end: {
            line: 30,
            column: 104
          }
        }],
        line: 30
      },
      "9": {
        loc: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 34
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 34
          }
        }, {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 34
          }
        }],
        line: 32
      },
      "10": {
        loc: {
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 35,
            column: 72
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 35,
            column: 72
          }
        }, {
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 35,
            column: 72
          }
        }],
        line: 34
      },
      "11": {
        loc: {
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 34,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 34,
            column: 30
          }
        }, {
          start: {
            line: 34,
            column: 34
          },
          end: {
            line: 34,
            column: 66
          }
        }],
        line: 34
      },
      "12": {
        loc: {
          start: {
            line: 41,
            column: 47
          },
          end: {
            line: 41,
            column: 59
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 41,
            column: 57
          },
          end: {
            line: 41,
            column: 59
          }
        }],
        line: 41
      },
      "13": {
        loc: {
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        }, {
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        }],
        line: 42
      },
      "14": {
        loc: {
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 48,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 48,
            column: 3
          }
        }, {
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 48,
            column: 3
          }
        }],
        line: 46
      },
      "15": {
        loc: {
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 46,
            column: 92
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 46,
            column: 30
          }
        }, {
          start: {
            line: 46,
            column: 34
          },
          end: {
            line: 46,
            column: 47
          }
        }, {
          start: {
            line: 46,
            column: 51
          },
          end: {
            line: 46,
            column: 75
          }
        }, {
          start: {
            line: 46,
            column: 79
          },
          end: {
            line: 46,
            column: 92
          }
        }],
        line: 46
      },
      "16": {
        loc: {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 58,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 58,
            column: 3
          }
        }, {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 58,
            column: 3
          }
        }],
        line: 56
      },
      "17": {
        loc: {
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 65,
            column: 34
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 65,
            column: 34
          }
        }, {
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 65,
            column: 34
          }
        }],
        line: 65
      },
      "18": {
        loc: {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        }, {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        }],
        line: 67
      },
      "19": {
        loc: {
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 67,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 67,
            column: 37
          }
        }, {
          start: {
            line: 67,
            column: 41
          },
          end: {
            line: 67,
            column: 62
          }
        }],
        line: 67
      },
      "20": {
        loc: {
          start: {
            line: 68,
            column: 6
          },
          end: {
            line: 71,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 68,
            column: 6
          },
          end: {
            line: 71,
            column: 7
          }
        }, {
          start: {
            line: 68,
            column: 6
          },
          end: {
            line: 71,
            column: 7
          }
        }],
        line: 68
      },
      "21": {
        loc: {
          start: {
            line: 68,
            column: 10
          },
          end: {
            line: 68,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 68,
            column: 10
          },
          end: {
            line: 68,
            column: 34
          }
        }, {
          start: {
            line: 68,
            column: 38
          },
          end: {
            line: 68,
            column: 62
          }
        }],
        line: 68
      },
      "22": {
        loc: {
          start: {
            line: 69,
            column: 8
          },
          end: {
            line: 69,
            column: 61
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 8
          },
          end: {
            line: 69,
            column: 61
          }
        }, {
          start: {
            line: 69,
            column: 8
          },
          end: {
            line: 69,
            column: 61
          }
        }],
        line: 69
      },
      "23": {
        loc: {
          start: {
            line: 73,
            column: 6
          },
          end: {
            line: 77,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 73,
            column: 6
          },
          end: {
            line: 77,
            column: 7
          }
        }, {
          start: {
            line: 73,
            column: 6
          },
          end: {
            line: 77,
            column: 7
          }
        }],
        line: 73
      },
      "24": {
        loc: {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 54
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 54
          }
        }, {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 54
          }
        }],
        line: 74
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0, 0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import deepEqual from 'deep-eql';

var _ref = (cov_1nywdp1kkt.s[0]++, Object.prototype),
    hasOwnProperty = _ref.hasOwnProperty;

function is(x, y) {
  cov_1nywdp1kkt.f[0]++;
  cov_1nywdp1kkt.s[1]++;

  if (x === y) {
    cov_1nywdp1kkt.b[0][0]++;
    cov_1nywdp1kkt.s[2]++;
    return (cov_1nywdp1kkt.b[1][0]++, x !== 0) || (cov_1nywdp1kkt.b[1][1]++, y !== 0) || (cov_1nywdp1kkt.b[1][2]++, 1 / x === 1 / y);
  } else {
    cov_1nywdp1kkt.b[0][1]++;
  } // eslint-disable-next-line


  cov_1nywdp1kkt.s[3]++;
  return (cov_1nywdp1kkt.b[2][0]++, x !== x) && (cov_1nywdp1kkt.b[2][1]++, y !== y);
}

function getOption(options, key) {
  cov_1nywdp1kkt.f[1]++;
  cov_1nywdp1kkt.s[4]++;

  if (!options[key]) {
    cov_1nywdp1kkt.b[3][0]++;
    cov_1nywdp1kkt.s[5]++;
    return [];
  } else {
    cov_1nywdp1kkt.b[3][1]++;
  }

  var val = (cov_1nywdp1kkt.s[6]++, options[key]);
  cov_1nywdp1kkt.s[7]++;
  return Array.isArray(val) ? (cov_1nywdp1kkt.b[4][0]++, val) : (cov_1nywdp1kkt.b[4][1]++, [val]);
}

export function compareColumns(columns1, columns2) {
  cov_1nywdp1kkt.f[2]++;
  cov_1nywdp1kkt.s[8]++;

  if ((cov_1nywdp1kkt.b[6][0]++, !columns1) || (cov_1nywdp1kkt.b[6][1]++, !columns2)) {
    cov_1nywdp1kkt.b[5][0]++;
    cov_1nywdp1kkt.s[9]++;
    return true;
  } else {
    cov_1nywdp1kkt.b[5][1]++;
  }

  cov_1nywdp1kkt.s[10]++;

  if (columns1.length !== columns2.length) {
    cov_1nywdp1kkt.b[7][0]++;
    cov_1nywdp1kkt.s[11]++;
    return false;
  } else {
    cov_1nywdp1kkt.b[7][1]++;
  }

  var simpleCompare = (cov_1nywdp1kkt.s[12]++, columns1.every(function (c, i) {
    cov_1nywdp1kkt.f[3]++;
    cov_1nywdp1kkt.s[13]++;
    return (cov_1nywdp1kkt.b[8][0]++, c.width === columns2[i].width) || (cov_1nywdp1kkt.b[8][1]++, Number.isNaN(c.width)) && (cov_1nywdp1kkt.b[8][2]++, Number.isNaN(columns2[i].width));
  }));
  cov_1nywdp1kkt.s[14]++;

  if (!simpleCompare) {
    cov_1nywdp1kkt.b[9][0]++;
    cov_1nywdp1kkt.s[15]++;
    return false;
  } else {
    cov_1nywdp1kkt.b[9][1]++;
  }

  var complexCompare = (cov_1nywdp1kkt.s[16]++, columns1.every(function (c, i) {
    cov_1nywdp1kkt.f[4]++;
    cov_1nywdp1kkt.s[17]++;

    if ((cov_1nywdp1kkt.b[11][0]++, Array.isArray(c.group)) && (cov_1nywdp1kkt.b[11][1]++, Array.isArray(columns2[i].group))) {
      cov_1nywdp1kkt.b[10][0]++;
      cov_1nywdp1kkt.s[18]++;
      return c.group.every(function (d, index) {
        cov_1nywdp1kkt.f[5]++;
        cov_1nywdp1kkt.s[19]++;
        return d === columns2[i].group[index];
      });
    } else {
      cov_1nywdp1kkt.b[10][1]++;
    }

    cov_1nywdp1kkt.s[20]++;
    return c.group === columns2[i].group;
  }));
  cov_1nywdp1kkt.s[21]++;
  return complexCompare;
}
export default function (objA, objB) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_1nywdp1kkt.b[12][0]++, {});
  cov_1nywdp1kkt.f[6]++;
  cov_1nywdp1kkt.s[22]++;

  if (is(objA, objB)) {
    cov_1nywdp1kkt.b[13][0]++;
    cov_1nywdp1kkt.s[23]++;
    return true;
  } else {
    cov_1nywdp1kkt.b[13][1]++;
  }

  cov_1nywdp1kkt.s[24]++;

  if ((cov_1nywdp1kkt.b[15][0]++, typeof objA !== 'object') || (cov_1nywdp1kkt.b[15][1]++, objA === null) || (cov_1nywdp1kkt.b[15][2]++, typeof objB !== 'object') || (cov_1nywdp1kkt.b[15][3]++, objB === null)) {
    cov_1nywdp1kkt.b[14][0]++;
    cov_1nywdp1kkt.s[25]++;
    return false;
  } else {
    cov_1nywdp1kkt.b[14][1]++;
  }

  var keysA = (cov_1nywdp1kkt.s[26]++, Object.keys(objA));
  var keysB = (cov_1nywdp1kkt.s[27]++, Object.keys(objB));
  var skip = (cov_1nywdp1kkt.s[28]++, getOption(options, 'skip'));
  var deep = (cov_1nywdp1kkt.s[29]++, getOption(options, 'deep'));
  cov_1nywdp1kkt.s[30]++;

  if (keysA.length !== keysB.length) {
    cov_1nywdp1kkt.b[16][0]++;
    cov_1nywdp1kkt.s[31]++;
    return false;
  } else {
    cov_1nywdp1kkt.b[16][1]++;
  }

  cov_1nywdp1kkt.s[32]++;
  keysA.sort(function (a, b) {
    cov_1nywdp1kkt.f[7]++;
    cov_1nywdp1kkt.s[33]++;
    return deep.indexOf(a) - deep.indexOf(b);
  }); // Test for A's keys different from B.

  cov_1nywdp1kkt.s[34]++;

  for (var i = 0; i < keysA.length; i++) {
    var k = (cov_1nywdp1kkt.s[35]++, keysA[i]);
    cov_1nywdp1kkt.s[36]++;

    if (skip.includes(k)) {
      cov_1nywdp1kkt.b[17][0]++;
      cov_1nywdp1kkt.s[37]++;
      continue;
    } else {
      cov_1nywdp1kkt.b[17][1]++;
    }

    cov_1nywdp1kkt.s[38]++;

    if ((cov_1nywdp1kkt.b[19][0]++, !hasOwnProperty.call(objB, k)) || (cov_1nywdp1kkt.b[19][1]++, !is(objA[k], objB[k]))) {
      cov_1nywdp1kkt.b[18][0]++;
      cov_1nywdp1kkt.s[39]++;

      if ((cov_1nywdp1kkt.b[21][0]++, objA[k] instanceof Error) && (cov_1nywdp1kkt.b[21][1]++, objB[k] instanceof Error)) {
        cov_1nywdp1kkt.b[20][0]++;
        cov_1nywdp1kkt.s[40]++;

        if (objA[k].message !== objB[k].message) {
          cov_1nywdp1kkt.b[22][0]++;
          cov_1nywdp1kkt.s[41]++;
          return false;
        } else {
          cov_1nywdp1kkt.b[22][1]++;
        }

        cov_1nywdp1kkt.s[42]++;
        continue;
      } else {
        cov_1nywdp1kkt.b[20][1]++;
      }

      cov_1nywdp1kkt.s[43]++;

      if (deep.includes(k)) {
        cov_1nywdp1kkt.b[23][0]++;
        cov_1nywdp1kkt.s[44]++;

        if (!deepEqual(objA[k], objB[k])) {
          cov_1nywdp1kkt.b[24][0]++;
          cov_1nywdp1kkt.s[45]++;
          return false;
        } else {
          cov_1nywdp1kkt.b[24][1]++;
        }
      } else {
        cov_1nywdp1kkt.b[23][1]++;
        cov_1nywdp1kkt.s[46]++;
        return false;
      }
    } else {
      cov_1nywdp1kkt.b[18][1]++;
    }
  }

  cov_1nywdp1kkt.s[47]++;
  return true;
}